import { api } from './client';
import type { ErrorLogResponse, RateLimitLogResponse } from './types';

export function getErrors() {
  return api.get<ErrorLogResponse>('/api/admin/errors');
}

export function clearErrors() {
  return api.del<void>('/api/admin/errors');
}

export function getRateLimits() {
  return api.get<RateLimitLogResponse>('/api/admin/rate-limits');
}

export function clearRateLimits() {
  return api.del<void>('/api/admin/rate-limits');
}
